var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p_chat"},[_c('iframe',{staticStyle:{"width":"100%","height":"99vh","min-height":"700px"},attrs:{"id":"ifm","src":'https://jobai.joball.net/chatbot/' + _vm.data,"frameborder":"0","allow":"microphone"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }